import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/api";

const API_URL = process.env.REACT_APP_LOCAL_HOST;

// Async thunk to fetch protected data
export const fetchProtectedData = createAsyncThunk(
  "/protectedData/fetchProtectedData",
  async (__dirname, thunkAPI) => {
    try {
      const response = await api.get(`${API_URL}/protected/test`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch protected data"
      );
    }
  }
);

const protectedDataSlice = createSlice({
  name: "protectedData",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProtectedData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchProtectedData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchProtectedData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const protectedDataReducer = protectedDataSlice.reducer;
